import React, { useEffect, useRef, useState } from 'react';

const InlineToast = ({ message, type = 'info', onClose }) => {
  const [visible, setVisible] = useState(false);
  const onCloseRef = useRef(onClose);
  useEffect(() => { onCloseRef.current = onClose; }, [onClose]);

  useEffect(() => {
    if (!message) {
      setVisible(false);
      return;
    }

    setVisible(true);

    const autoDismiss = setTimeout(() => {
      setVisible(false);
      setTimeout(() => onCloseRef.current && onCloseRef.current(), 300);
    }, 4000);

    return () => clearTimeout(autoDismiss);
  }, [message]);

  if (!message) return null;

  const styles = {
    success: {
      bar: 'bg-green-500',
      container: 'bg-white border-l-4 border-green-500 text-gray-800',
      icon: (
        <svg className="h-5 w-5 text-green-500 shrink-0" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
      )
    },
    error: {
      bar: 'bg-red-500',
      container: 'bg-white border-l-4 border-red-500 text-gray-800',
      icon: (
        <svg className="h-5 w-5 text-red-500 shrink-0" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
        </svg>
      )
    },
    info: {
      bar: 'bg-blue-500',
      container: 'bg-white border-l-4 border-blue-500 text-gray-800',
      icon: (
        <svg className="h-5 w-5 text-blue-500 shrink-0" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
        </svg>
      )
    }
  };

  const s = styles[type] || styles.info;

  return (
    <div
      className={`fixed top-20 right-4 z-50 w-80 rounded-lg shadow-lg overflow-hidden
        transition-all duration-300 ease-in-out
        ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-2 pointer-events-none'}`}
    >
      <div className={`${s.container} px-4 py-3`}>
        <div className="flex items-start gap-3">
          {s.icon}
          <p className="text-sm flex-1 leading-snug">{message}</p>
          {onClose && (
            <button
              type="button"
              onClick={() => {
                setVisible(false);
                setTimeout(() => onClose(), 300);
              }}
              className="text-gray-400 hover:text-gray-600 shrink-0 ml-1"
              aria-label="Dismiss"
            >
              <svg className="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            </button>
          )}
        </div>
      </div>
      {/* progress bar */}
      <div className={`h-1 ${s.bar} ${visible ? 'animate-shrink' : ''}`} />
    </div>
  );
};

export default InlineToast;
